import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n/i18n';
import styles from './Masthead.module.css';

export default function Masthead({ theme, onToggleTheme, onPrivacy, onHome, onShare, copied, hasResult, onPrint, onZakat, showHome }) {
  const { t } = useTranslation();
  const isDark = theme === 'dark';
  const currentLang = i18n.language;

  function switchLang(lang) {
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
  }

  return (
    <header className={styles.masthead}>
      {/* ── Top toolbar ── */}
      <div className={styles.toolbar}>
        <div className={styles.eyebrowRow}>
          {/* Home icon — only visible when there's a result to go back from */}
          {(hasResult || showHome) && (
            <button
              className={styles.homeBtn}
              onClick={onHome}
              title={t('masthead.home_title')}
              aria-label={t('masthead.home_title')}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              <span>{t('masthead.home_button')}</span>
            </button>
          )}
        </div>

        <div className={styles.actions}>
          {/* Zakat Calculator link */}
          {onZakat && (
            <button
              className={styles.zakatBtn}
              onClick={onZakat}
              title="Zakat Portfolio Calculator"
            >
              Zakat
            </button>
          )}
          {/* Print / export PDF */}
          {hasResult && (
            <button
              className={styles.iconBtn}
              onClick={onPrint}
              title={t('masthead.export_pdf')}
              aria-label={t('masthead.export_pdf')}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="6 9 6 2 18 2 18 9"/>
                <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
                <rect x="6" y="14" width="12" height="8"/>
              </svg>
            </button>
          )}

          {/* Share / copy permalink */}
          {hasResult && (
            <button
              className={`${styles.iconBtn} ${copied ? styles.iconBtnActive : ''}`}
              onClick={onShare}
              title={copied ? t('masthead.link_copied') : t('masthead.copy_link')}
              aria-label={copied ? t('masthead.link_copied') : t('masthead.copy_link')}
            >
              {copied ? (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              ) : (
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                </svg>
              )}
            </button>
          )}

          {/* Theme toggle */}
          <button
            className={styles.iconBtn}
            onClick={onToggleTheme}
            title={isDark ? t('masthead.switch_light') : t('masthead.switch_dark')}
            aria-label={isDark ? t('masthead.switch_light') : t('masthead.switch_dark')}
          >
            {isDark ? (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="5"/>
                <line x1="12" y1="1" x2="12" y2="3"/>
                <line x1="12" y1="21" x2="12" y2="23"/>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                <line x1="1" y1="12" x2="3" y2="12"/>
                <line x1="21" y1="12" x2="23" y2="12"/>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
              </svg>
            ) : (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
              </svg>
            )}
          </button>

          {/* Privacy / help icon */}
          <button
            className={styles.iconBtn}
            onClick={onPrivacy}
            title={t('masthead.learn_more')}
            aria-label={t('masthead.learn_more')}
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
          </button>

          {/* Language switcher */}
          {/* <div className={styles.langSwitcher}>
            <button
              className={`${styles.langBtn} ${currentLang === 'en' ? styles.langBtnActive : ''}`}
              onClick={() => switchLang('en')}
              aria-label="Switch to English"
            >EN</button>
            <button
              className={`${styles.langBtn} ${currentLang === 'fr' ? styles.langBtnActive : ''}`}
              onClick={() => switchLang('fr')}
              aria-label="Passer en français"
            >FR</button>
          </div> */}
        </div>
      </div>

      <h1 className={styles.title}>
        {t('masthead.title_line1')} <em>{t('masthead.title_emphasis')}</em><br />{t('masthead.title_line2')}
      </h1>
      <p className={styles.sub}>{t('masthead.subtitle')}</p>
    </header>
  );
}
